import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Box } from "@mui/material";
import { LibraryAdd } from "@mui/icons-material";
import PropTypes from "prop-types";

const HeaderButtons = ({ onAddShortCourse }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      my={2}
      flexDirection={{ xs: "column", sm: "row" }}
      flexWrap="wrap"
    >
      <Button
        startIcon={<LibraryAdd />}
        onClick={onAddShortCourse}
        color="primary"
        size="large"
      >
        {t("courseVersion.details.addShortCourseBtn")}
      </Button>
    </Box>
  );
};

export default HeaderButtons;

HeaderButtons.propTypes = {
  onAddShortCourse: PropTypes.func
};
